module.exports = __webpack_public_path__ + "static/media/logo_sky_rec_prog.e59d00ef.svg";